module.exports = __webpack_public_path__ + "static/img/2004.e7def6c9.jpg";